import {EAddress} from '../Subscribers/definitions';
import {EDeliveryStatus, EDialogStatus, EMessageDirection, EMessageSource} from './definitions';

export default {
  title: 'Dialog messages',
  dialog: 'Dialog',
  channel: 'channel',
  empty: 'You have no incoming messages yet',
  loadMore: 'Load more',
  backToDialogs: 'Back to dialogs',
  messageSource: 'Source: source',
  initiator: 'Initiator: userId',
  subscriber: 'Recipient',
  operator: 'Operator',
  yesterday: 'Yesterday',
  today: 'Today',
  inputPlaceholder: 'Message text',
  templateOnlyPlaceholder: 'You can only reply with a template message.',
  templates: 'Templates',
  direction: {
    [EMessageDirection.IN]: 'Incoming',
    [EMessageDirection.OUT]: 'Outgoing',
  },
  deliveryStatus: {
    [EDeliveryStatus.ENQUEUED]: 'Queued',
    [EDeliveryStatus.SENT]: 'Sent',
    [EDeliveryStatus.FAILED]: 'Failed to send',
    [EDeliveryStatus.ACCEPTED]: 'Failed to send',
    [EDeliveryStatus.INVALID]: 'Failed to send',
    [EDeliveryStatus.DELIVERED]: 'Delivered',
    [EDeliveryStatus.CANCELLED]: 'Canceled',
    [EDeliveryStatus.UNDELIVERED]: 'Not delivered',
    [EDeliveryStatus.READ]: 'Read',
    [EDeliveryStatus.EXPIRED]: 'Expired',
    [EDeliveryStatus.BLOCKED]: 'Blocked',
    [EDeliveryStatus.SUSPENDED]: 'Suspended',
  },
  dialogStatus: {
    [EDialogStatus.ANSWERED]: 'Answered',
    [EDialogStatus.UNANSWERED]: 'Unanswered',
  },
  dialogStatusTabs: {
    ALL: 'All dialogs',
    [EDialogStatus.UNANSWERED]: 'Awaiting reply',
  },
  dialogAnswered: 'Dialog answered',
  content: {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    document: 'Document',
    location: 'Location',
    contact: 'Contact',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    link: 'Link',
    name: 'Name',
    value: 'Value',
    replyButton: 'Chat button',
    requestCallPermission: 'Call request',
    flow: 'Flow interaction',
    hasButtons: 'Message contains buttons',
    showPreview: 'Show',
  },
  requestCallPermission: {
    1: 'Allow calls',
    2: 'Temporarily allow calls',
    3: 'Do not allow',
  },
  clientAnswered: 'Client replied',
  clientFlow: 'Client interacted with Flow',
  openMap: 'Open on map',
  dialogsTitle: 'Dialogs',
  unknownClient: 'Unknown client',
  preview: {
    photo: '<Photo>',
    video: '<Video>',
    audio: '<Audio>',
    file: '<File>',
    voice: '<Voice message>',
    location: '<Location>',
    contact: '<Contact>',
    callPermissionReply: '<Call request reply>',
  },
  fileSizeExceeded: 'Maximum file size exceeded: size MB',
  subjectLocked:
    'Messaging in this channel is currently unavailable. Please check the license status.',
  toLicenses: 'Go to licenses',
  dialogExpired:
    'This conversation ended more than 24 hours ago. To send a message to the client, create and send a broadcast.',
  toBroadcasts: 'Go to broadcasts',
  clientProfile: 'Client profile',
  editProfile: 'Edit profile',
  clientParameters: 'Recipient variables',
  addresses: {
    [EAddress.WHATSAPP_BSUID]: 'WA BSUID',
    [EAddress.MAX_ID]: 'Max_ID',
    [EAddress.TELEGRAM_ID]: 'Telegram_ID',
  },
  sendTemplateMessage: {
    button: 'Template',
    title: 'Send template message',
    selectTemplate: 'Select a broadcast template',
    send: 'Send',
  },
  search: {
    placeholder: 'Search by name, phone or ID',
    noResults: 'No recipient or dialogs found',
    subscriberFoundNoDialogs:
      'Recipient exists in our database but has not sent any incoming messages yet.',
    notFoundCanCreate:
      'We did not find such a recipient or dialogs. Add a recipient to start a conversation.',
    notFoundNoInitiation:
      'We have no dialog with this client. An incoming message from this user is required to start a dialog.',
    writeToClient: 'Write to client',
    createDialog: 'Create dialog',
    addSubscriber: 'Add recipient',
    writeInAnotherChannel: 'Write in another channel',
  },
  createDialog: {
    titleCreate: 'Create recipient and dialog',
    titleStartDialog: 'Create dialog',
    phone: 'Phone',
    firstName: 'First name (optional)',
    lastName: 'Last name (optional)',
    channelLabel: 'Channel for dialog',
    channelPlaceholder: 'Select',
    cancel: 'Cancel',
    create: 'Create',
    creating: 'One moment, creating dialog in new channel',
  },
  emptyList: "You're all caught up! You've replied to all client dialogs.",
  newDialog: {
    title: 'You have no dialog yet',
    subtitle: 'To create a dialog, send a message',
  },
  sourceName: {
    [EMessageSource.FLOW]: 'Scenario',
    [EMessageSource.IMHPX]: 'Chat Center',
    [EMessageSource.JIVO]: 'Jivo',
    [EMessageSource.BROADCAST]: 'Personal account',
    [EMessageSource.JSON_API]: 'API',
    [EMessageSource.OUT_MESSAGE]: 'API',
    [EMessageSource.INTERNAL_API]: 'Test',
    [EMessageSource.BROADCAST_TEST_MESSAGE]: 'Test',
    [EMessageSource.WHATSAPP_BUSINESS_APP]: 'WhatsApp Business App',
  },
};
